import { makeStyles } from '@material-ui/core/styles';

const useUserManagementStyles = makeStyles(() => ({
    container: { padding: '16px 24px' },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
        marginBottom: 12,
    },
    toolbarActions: { display: 'flex', alignItems: 'center', gap: 8 },
    scopeBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 10px',
        borderRadius: 12,
        background: '#eef0fb',
        color: '#43419e',
        fontSize: 12,
        fontWeight: 600,
    },
    missingScope: { color: '#c62828', fontSize: 12, fontWeight: 600 },
    tableWrapper: { maxHeight: 'calc(100vh - 260px)' },
    emptyState: { padding: '48px 0', textAlign: 'center', color: '#6b7280' },
}));

export default useUserManagementStyles;
